import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private readonly TOKEN_KEY = 'auth_token';

  setToken(token: string): void {
    console.log('[TokenService] Setting token:', token);
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  getToken(): string | null {
    const token = localStorage.getItem(this.TOKEN_KEY);
    console.log('[TokenService] Getting token:', token);
    return token;
  }

  clearToken(): void {
    console.log('[TokenService] Clearing token');
    localStorage.removeItem(this.TOKEN_KEY);
  }
  
}
